import Repositories from "@/repositories";
export const state = {
  layoutType: 'horizontal',
  layoutWidth: 'fluid',
  leftSidebarType: 'dark',
  topbar: 'dark',
  loader: false,
  logo: undefined,
  organisationcode_logo: null
}

export const mutations = {
  CHANGE_LAYOUT(state, layoutType) {
    state.layoutType = layoutType;
  },
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
  },
  CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
    state.leftSidebarType = leftSidebarType;
  },
  CHANGE_TOPBAR(state, topbar) {
    state.topbar = topbar;
  },
  LOADER(state, loader) {
    state.loader = loader
  },
  CHANGE_LOGO(state, data) {
    state.logo = data.logo;
    state.organisationcode_logo = data.organisationcode;
  }
}

export const actions = {
  changeLayoutType({ commit }, { layoutType }) {
    commit('CHANGE_LAYOUT', layoutType);
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth)
  },

  changeLeftSidebarType({ commit }, { leftSidebarType }) {
    commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType)
  },

  changeTopbar({ commit }, { topbar }) {
    commit('CHANGE_TOPBAR', topbar)
  },

  changeLoaderValue({ commit }, { loader }) {
    commit('LOADER', loader)
  },

  loadLogo({ commit }, routeOrganisationCode) {
    var repository = Repositories.get("organisationconfiguration", routeOrganisationCode);
    
    if (state.organisationcode_logo !== routeOrganisationCode) {
      repository.actions.getLogo().then((result) => {
        commit("CHANGE_LOGO", { logo: result.data, organisationcode: routeOrganisationCode})
      }, (error) => {
        if (error.response.status == 404) {
          this.$router.push({ name: '404' });
        }
        else {
          window.console.error(error);
        }
      });
    }
  }
}
